export default __webpack_public_path__ + "static/media/NotoSansKR-Medium.865a70c3.woff";